import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import InfoContent from '../BlogContent/InfoContent';
import List from '../BlogContent/List';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';

const Blog8 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_8;

    const {title, p} = InfoContent.Blog_8.one;
    const {title2, p2} = InfoContent.Blog_8.two;
    const {title3, p3} = InfoContent.Blog_8.three;
    const {title4, p4} = InfoContent.Blog_8.four;
    const {title5, p5} = InfoContent.Blog_8.five;
    const {title6, p6} = InfoContent.Blog_8.six;
    const {title7, p7} = InfoContent.Blog_8.seven;
    const {title8, p8} = InfoContent.Blog_8.eight;
    const {title9, p9} = InfoContent.Blog_8.nine;
    const {title10, p10} = InfoContent.Blog_8.ten;
    const {title11, p11} = InfoContent.Blog_8.eleven;
    const {title12, p12} = InfoContent.Blog_8.twelve;
    
    const {Ctitle, Cp} = InfoContent.Blog_8.conclusion;

    const {liss} = ListContent.Blog_8.L1;
    const {liss2} = ListContent.Blog_8.L2;
    const {liss3} = ListContent.Blog_8.L3;
    const {liss4} = ListContent.Blog_8.L4;
    const {liss5} = ListContent.Blog_8.L5;
    const {liss6} = ListContent.Blog_8.L6;
    const {liss7} = ListContent.Blog_8.L7;
    const {liss8} = ListContent.Blog_8.L8;
    const {liss9} = ListContent.Blog_8.L9;
    const {liss10} = ListContent.Blog_8.L10;
    const {liss11} = ListContent.Blog_8.L11;
    const {liss12} = ListContent.Blog_8.L12;
    const {liss13} = ListContent.Blog_8.L13;

  return (
    <>
   <AboutInnerBanner image={image} heading={heading} pageName={pageName}/>
   
       <div className="blog-area pt-100 pb-70">
       <div className="container">
           <div className="row">
               <div className="col-lg-8">
                <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                <Info title={title} p={p} />
                <Info title={title2} p={p2} />
                <h4>Include:</h4>
                <List liss={liss} />

                <h4>Avoid:</h4>
                <List liss={liss2} />
                
                <Info title={title3} p={p3} />
                <h4>Try:</h4>
                <List liss={liss3} />
                
                <Info title={title4} p={p4} />
                <h4>Women: </h4>
                <List liss={liss4}/>
                <h4>Men: </h4>
                <List liss={liss5}/>

                <Info title={title5} p={p5} />
                <List liss={liss6}/>

                <Info title={title6} p={p6} />
                <h4>How to Track: </h4>
                <List liss={liss7}/>

                <Info title={title7} p={p7} />
                <h4>Swap out:</h4>
                <List liss={liss8}/>

                <Info title={title8} p={p8} />
                <h4>Men Should:</h4>
                <List liss={liss9}/>

                <Info title={title9} p={p9} />
                <h4>Test for:</h4>
                <List liss={liss10}/>

                <Info title={title10} p={p10} />
                <h4>Tips:</h4>
                <List liss={liss11}/>

                <Info title={title11} p={p11} />
                <h4>Common Fertility Supplements:</h4>
                <List liss={liss12}/>

                <Info title={title12} p={p12} />
                <h4>If you’ve been trying for:</h4>
                <List liss={liss13}/>


                <Info title={Ctitle} p={Cp} />
               </div>
               <div className="col-lg-4">
                   <RecentBlogsList/>
                   <RightHandSide/>
               </div>
           </div>
       </div>
       </div>
    </>
  )
}

export default Blog8